// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-button-subtext[data-v-c4bd51f8] {\n  color: var(--carbon-600);\n}", ""]);
// Exports
module.exports = exports;
